import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useLang } from "@/lib/LanguageContext";
import PageShell from "@/components/PageShell";
import ImageHero from "@/components/ImageHero";
import Seo from "@/components/Seo";

export default function HowItWorksPage() {
  const { t } = useLang();
  const h = t.howItWorks;

  return (
    <PageShell>
      <Seo title={h.seoTitle} description={h.seoDesc} />

      <ImageHero testId="how-hero" image="executiveDesk" eyebrow={h.eyebrow} titleA={h.title} text={h.intro} />

      <section data-testid="how-steps" className="py-16 sm:py-32 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-px bg-stone-200 border border-stone-200">
          {h.steps.map((s) => (
            <div key={s.n} data-testid={`how-step-${s.n}`} className="bg-stone-50 p-10 sm:p-14">
              <span className="font-serif text-4xl text-stone-300">{s.n}</span>
              <h2 className="mt-6 font-serif text-2xl text-stone-900">{s.title}</h2>
              <p className="mt-4 text-stone-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section data-testid="how-cta" className="bg-slate-900 text-stone-200 py-16 sm:py-32 px-6 lg:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-serif text-4xl sm:text-5xl font-light text-stone-50">{h.ctaTitle}</h2>
          <p className="mt-6 text-stone-400 text-lg">{h.ctaText}</p>
          <Link
            data-testid="how-cta-contact"
            to="/contact"
            className="mt-10 inline-flex items-center justify-center gap-3 bg-stone-50 text-slate-900 px-8 py-4 text-sm font-medium hover:bg-stone-200 transition-colors"
          >
            {t.finalCta.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
